import React from 'react';
import FaceDownCard from './FaceDownCard';
import FaceUpCard from './FaceUpCard';
import FaceUpCardLarge from './FaceUpCardLarge';
import { Player } from '../classes/Player';
import { Round } from '../classes/Round';
import { RoundBlackCard } from '../classes/RoundBlackCards';
import { Popups } from '../constants/Popups';
import { cutText, getRedCardText } from '../utils/TextsUtils';

interface SelectBlackCardDialogInterface {
    gameId: string;
    statsId: number;
    playerId: number;
    currentRound: Round;
    roundBlackCards: RoundBlackCard[];
    judge: Player;
    criminal: Player;
    scoresMap: Map<number, number>;
    lastOpenRoundBlackCardIdx: number;
    popup: Popups;
    handleCloseOpenedBlackCard: any;
}

function SelectBlackCardDialog({gameId, statsId, playerId, currentRound, roundBlackCards, judge, criminal, scoresMap, lastOpenRoundBlackCardIdx, popup, handleCloseOpenedBlackCard}: SelectBlackCardDialogInterface) {
    const playerImage = require("../images/avatars/" + criminal.image + ".png");

    const allBlackCardsAreOpen = () => {
        for (let idx = 0; idx < roundBlackCards.length; idx++) {
            if (roundBlackCards[idx].blackCardIdx > -1 && roundBlackCards[idx].isOpen === false) {
                return false;
            }
        }
        return true;
    }

    const shouldShowDragCriminalText = () => {
        return playerId === judge.id && allBlackCardsAreOpen() && popup === Popups.none && lastOpenRoundBlackCardIdx === -1;
    }

    return (
        <div className="selectBlackCardOuterWrapper">
            <div className="selectBlackCardWrapper">
                <div className="selectBlackCardMiddle">
                    <div className="selectBlackCardRedCardTextWrapper">
                        <div className="selectBlackCardRedCardText">
                            {getRedCardText(currentRound.redCardIdx, criminal.name, criminal.gender)}
                        </div>
                    </div>
                    
                    {playerId !== judge.id && <div className="selectBlackCardRedCardJudgeText">
                        {"Judge: " + judge.name}
                    </div>}
                </div>
                <div className="selectBlackCardBottom">
                    <div className="selectBlackCardCardsVerticalWrapper">
                        {
                            roundBlackCards.map((card, idx) => card.isOpen
                                ? <FaceUpCard key={idx} gameId={gameId} statsId={statsId} roundBlackCards={roundBlackCards} criminal={criminal} scoresMap={scoresMap} roundBlackCardIdx={idx} isJudge={playerId === judge.id}/>
                                : <FaceDownCard key={idx} roundBlackCards={roundBlackCards} roundBlackCardIdx={idx} isJudge={playerId === judge.id}/>
                            )
                        }
                        <div className="selectBlackCardInfoWrapper">
                            <div className="selectBlackCardInfoText">
                                {playerId !== judge.id
                                    ? "Watch as Judge reviews submissions"
                                    : shouldShowDragCriminalText()
                                        ? "Click on winning card"
                                        : ""}
                            </div>
                            {playerId === judge.id && <div className="selectBlackCardCriminalWrapper"
                                draggable
                                //onDragStart={handleDragStart}
                            >
                                <img className="selectBlackCardCriminalImage" src={playerImage} alt="player avatar"/>
                                <div className="selectBlackCardCriminalName">
                                    {cutText(criminal.name, 15)}
                                </div>
                            </div>}
                        </div>
                    </div>
                    {lastOpenRoundBlackCardIdx >= 0 && lastOpenRoundBlackCardIdx < roundBlackCards.length && playerId === judge.id && <FaceUpCardLarge playerId={playerId} currentRound={currentRound} roundBlackCard={roundBlackCards[lastOpenRoundBlackCardIdx]} criminal={criminal} handleCloseOpenedBlackCard={handleCloseOpenedBlackCard}/>}
                </div>
            </div>
        </div>
    );
};

export default SelectBlackCardDialog;